import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rectangle-simmer',
  templateUrl: './rectangle-simmer.component.html',
  styleUrls: ['./rectangle-simmer.component.css']
})
export class RectangleSimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
